/**
 * @generated SignedSource<<8974054a22df1d8da976e931f5fc1597>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UpdateCategoryInput = {
  aliasOf?: string | null | undefined;
  clientMutationId?: string | null | undefined;
  description?: string | null | undefined;
  id: string;
  name?: string | null | undefined;
  parentDatabaseId?: number | null | undefined;
  parentId?: string | null | undefined;
  pinnedContent?: ReadonlyArray<string | null | undefined> | null | undefined;
  slug?: string | null | undefined;
  uxOrder?: number | null | undefined;
};
export type Category_Update_Mutation$variables = {
  input: UpdateCategoryInput;
};
export type Category_Update_Mutation$data = {
  readonly updateCategory: {
    readonly category: {
      readonly id: string;
      readonly name: string | null | undefined;
      readonly znglycategory: {
        readonly uxOrder: number | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type Category_Update_Mutation$rawResponse = {
  readonly updateCategory: {
    readonly category: {
      readonly id: string;
      readonly name: string | null | undefined;
      readonly znglycategory: {
        readonly uxOrder: number | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type Category_Update_Mutation = {
  rawResponse: Category_Update_Mutation$rawResponse;
  response: Category_Update_Mutation$data;
  variables: Category_Update_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateCategoryPayload",
    "kind": "LinkedField",
    "name": "updateCategory",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Category",
        "kind": "LinkedField",
        "name": "category",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Category_Znglycategory",
            "kind": "LinkedField",
            "name": "znglycategory",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "uxOrder",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Category_Update_Mutation",
    "selections": (v1/*: any*/),
    "type": "RootMutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Category_Update_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7fb4ea0339d31d2985dd2938ad693b09",
    "id": null,
    "metadata": {},
    "name": "Category_Update_Mutation",
    "operationKind": "mutation",
    "text": "mutation Category_Update_Mutation(\n  $input: UpdateCategoryInput!\n) {\n  updateCategory(input: $input) {\n    category {\n      id\n      name\n      znglycategory {\n        uxOrder\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "08e8f16793264b638d4d5aa843a5e741";

export default node;
